import { render } from "./sales_and_collection_analysis.vue?vue&type=template&id=6172cbde"
import script from "./sales_and_collection_analysis.vue?vue&type=script&lang=js"
export * from "./sales_and_collection_analysis.vue?vue&type=script&lang=js"

import "./sales_and_collection_analysis.vue?vue&type=style&index=0&id=6172cbde&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__